var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"notifications",class:_vm.notificationsTopPos},_vm._l((_vm.notificationStore),function(notification){return _c('div',{key:notification.uuid},[_c('notification',{attrs:{"notification":notification}})],1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }